export default __webpack_public_path__ + "static/media/Visionandmission1.8a57c637.svg";